import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classNames from 'classnames';
import { usePopper } from 'react-popper';
import MenuItems from '../menuItems/MenuItems';
import MenuItemList from '../menuItems/MenuItemList';
const DropdownSubmenu = (props) => {
    const { title = '', items = [], disabled = false, className } = props, remainingProps = __rest(props, ["title", "items", "disabled", "className"]);
    const classes = classNames('dropdown-submenu', disabled && 'disabled', className);
    const [refParentPopper, setRefParentPopper] = useState(null);
    const [refDropdownSubmenu, setRefDropdownSubmenu] = useState(null);
    // We have to use the workaround of checking the hover state as popper may render
    // the sub menu on an odd place and fixes it's position on the next render cycle
    const [isHover, setIsHover] = useState(false);
    const handleMouseEnter = () => setIsHover(true);
    const handleMouseLeave = () => setIsHover(false);
    const { styles, attributes } = usePopper(refParentPopper, refDropdownSubmenu, {
        placement: 'right-start',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [-4, 0],
                },
            },
        ],
    });
    // return a list item that is also automatically the new toggle for the submenu
    return (_jsxs("li", Object.assign({ ref: setRefParentPopper }, remainingProps, { className: classes, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: [_jsxs("a", Object.assign({ className: 'submenu-title', role: 'menuitem' }, { children: [_jsx("span", Object.assign({ className: 'submenu-title-text' }, { children: title })), _jsx("span", { className: 'rioglyph rioglyph-chevron-right' })] })), isHover && !disabled && (_jsx(MenuItemList, Object.assign({ ref: setRefDropdownSubmenu, style: styles.popper }, attributes.popper, { children: _jsx(MenuItems, { items: items }) })))] })));
};
export default DropdownSubmenu;
